import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const ProfileRow = ({
  label,
  children,
  className,
}) => {
  const classNameList = classNames('row row-field', className)

  return (
    <div className={classNameList}>
      <div className="col-md-4 bold">
        <div className="form-group">{label}</div>
      </div>
      <div className="col-md-8">
        {children}
      </div>
    </div>
  )
}

ProfileRow.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
}

ProfileRow.defaultProps = {
  label: '',
  className: '',
}

export default ProfileRow
